function ShowMenuImage() {
    if ($(window).width() > 992) {
        $("#MainMenu > ul > li").hover(function () {

            $BannerImage = $(this).find(".MenuBanner img");

            if ($BannerImage.attr("data-oimage") != undefined) {

                var Oiamge = $BannerImage.attr("data-oimage");
                $BannerImage.attr("src", Oiamge);
                $BannerImage.removeAttr("data-oimage");
            }
        });
    }
}

function MobileHeaderSetting() {
    $('.RightAccount').live('click', function (e) {
        if (isMobile(true)) {
            var IsLogged = $(this).hasClass("Logged");

            if (IsLogged) {
                var isCartActive = $(".RightAccount").hasClass("active");

                if (isCartActive) {
                    $("body").removeClass("BackDropped");
                    $(".RightAccount").removeClass("active");
                    $(".RightBasket").addClass("active");
                }
                else {
                    $("body").addClass("BackDropped");
                    $(".RightAccount").addClass("active");
                    $(".RightBasket").removeClass("active");
                }

                //e.preventDefault;
                //return false;
            }
        }
    });

    if ($(window).width() < 992) {

        $(".Mainmenu .itemsWrapper .ListWrapper > li > ul > li > ul").each(function () {
            if ($(this).find("li").length <= 0) {
                $(this.remove());
            }
        });

        //cloneKoleksiyon = $(".Mainmenu .itemsWrapper li[data-rel='375'] ul").html();
        //$(".Mainmenu .itemsWrapper li[data-rel='375']").closest(".itemsWrapper").append(cloneKoleksiyon);
        //$(".Mainmenu .itemsWrapper li[data-rel='375']").closest(".ListWrapper").remove();

        //cloneFirsatlar = $(".Mainmenu .itemsWrapper li[data-rel='378'] ul").html();
        //$(".Mainmenu .itemsWrapper li[data-rel='378']").closest(".itemsWrapper").append(cloneFirsatlar);
        //$(".Mainmenu .itemsWrapper li[data-rel='378']").closest(".ListWrapper").remove();

        $("#MainMenu .Mainmenu .itemsWrapper .ListWrapper > li").unwrap();

        //$('#MainMenu .Mainmenu').hcOffcanvasNav({
        //    maxWidth: 992,
        //    levelSpacing: 20,
        //    navClass: 'MobilLeftMenu',
        //    labelClose: 'Kapat',
        //    labelBack: 'Geri',
        //    position: 'left'
        //});

        //Mobile Menu item special color
        if ($("nav.MobilLeftMenu ul.Mainmenu > li > a[data-rel='442']").length > 0 && isMobile(true)) {
            $("nav.MobilLeftMenu ul.Mainmenu > li > a[data-rel='442']").addClass('SpecialColor');
        }

        var lastScroll = 100;
        $(window).scroll(function () {
            if ($(window).scrollTop() >= lastScroll) {
                $(".header-mobile-search").removeClass("open");
            }

            lastScroll = $(window).scrollTop();
        });
    }
}

function DesktopHeaderSetting() {
    if ($(window).width() > 991) {

        //Mouse menü üzerine geldiğinde arka planı karartan js - headerde navmenü olmadığı için yeni tasarımda kapatıldı
        //$("#MainMenu > ul > li").live({
        //    mouseenter:
        //        function () {
        //            if ($(this).find(".itemsWrapper").length > 0 && !$("#RegisterLoginModal").is(":visible")) {
        //                $("body").addClass("BackDropped");
        //            }
        //        },
        //    mouseleave:
        //        function () {
        //            if ($(".SearchModal").css("display") != "block") {
        //                $("body").removeClass("BackDropped");
        //                $("ul#MainMenu.Monitor > li").removeClass("open");
        //            }
        //        }
        //});

        $(".RightAccount").live({
            mouseenter:
                function () {
                    if ($(this).find("#AccountMenu").length > 0) {
                        $("body").addClass("BackDropped");
                    }
                },
            mouseleave:
                function () {
                    if ($(".SearchModal").css("display") != "block") {
                        $("body").removeClass("BackDropped");
                        $("ul#MainMenu.Monitor > li").removeClass("open");
                    }
                }
        });

    }
}

function MenuHover() {
    if ($(window).width() > 991) {

        //Mouse menü üzerine geldiğinde arka planı karartan js - headerde navmenü olmadığı için yeni tasarımda kapatıldı
        $(".sorsfont-menu").live({
            mouseenter:
                function () {
                    $(".nav-menu").toggleClass("open");
                    $(".backdrop").toggleClass("ShowBackdrop");
                    $(".sorsfont-menu").toggleClass("sorsfont-menu-reversed");
                },

        });

        $(".ShowBackdrop").live({
            mouseenter:
                function () {
                    $(".nav-menu").removeClass("open");
                    $(".backdrop").removeClass("ShowBackdrop");
                    $(".sorsfont-menu").removeClass("sorsfont-menu-reversed");
                },

        });
    }
}

function MenuBannerSettings() {
    $DefaultImage = "";

    $(".ListWrapper > li").hover(function () {
        $BannerArea = $(this).parent().parent().find(".MenuBanner > img");
        $DefaultImage = $BannerArea.attr("src");

        if ($(this).data("img") != "" && $(this).data("img") != null) {
            $BannerArea.attr("src", $(this).data("img"));

        }
    }, function () {
        $BannerArea.attr("src", $DefaultImage);
    });
}

function HideOpenWindows() {
    $(".RightAccount ").removeClass("active");
    $("ul#MainMenu.Monitor > li").removeClass("open");

    $("ul#MainMenu.Monitor > li").removeClass("open");
}

//Gtag için katalog push gerekli script
function GtagDatalayerCatalogEvent() {

    $(document).on("click", ".Mainmenu li > a", function () {

        var element = $(this);
        var catName1 = null;
        var catName2 = null;
        var catName3 = null;

        if (element.closest(".itemsWrapper").length > 0) {
            var parentelement = element.closest(".itemsWrapper");

            if (parentelement.parents(".itemsWrapper").length > 0) {
                catName1 = parentelement.parents(".itemsWrapper").prev().text();
                catName2 = element.closest(".itemsWrapper").prev().text();
                catName3 = element.text();
            } else {
                catName1 = element.closest(".itemsWrapper").prev().text();
                catName2 = element.text();
            }
        }
        else {
            catName1 = element.text();
        }

        dataLayer.push({
            'event': 'custom_event',
            'event_category': 'click',
            'event_action': 'menu_click',
            'menu_type': 'header',
            'menu_cat1': catName1,
            'menu_cat2': catName2,
            'menu_cat3': catName3
        });
    });

}

$(document).ready(function () {
    ShowMenuImage();
    MobileHeaderSetting();
    DesktopHeaderSetting();
    MenuBannerSettings();
    GtagDatalayerCatalogEvent();
    MenuHover();
    updateHeaderStyles();

    function updateHeaderStyles() {

        var header = document.querySelector('header');

        var anoncement = document.querySelector('#AnoncementArea');

        var countdown = document.querySelector('#CountDownWrapper');

        var anoncementHeight = 0;

        var headerHeight = 0;

        var countdownHeight = 0;

        if (anoncement != null) {
            anoncementHeight = anoncement.offsetHeight;
        }

        if (countdown != null) {
            countdownHeight = countdown.offsetHeight;
        }

        if ($(window).width() > 991) {
            headerHeight = header.offsetHeight;
        }

        var totalHeight = headerHeight + anoncementHeight + countdownHeight;

        //console.log(totalHeight);
        //console.log(headerHeight);
        //console.log(anoncementHeight);

        $(".nav-menu").css("top", totalHeight + "px");

        if ($(window).scrollTop() >= 1) {
            $("header").addClass("fixed-menu");
            $(".nav-menu").addClass("fixed-nav-menu");

            $(".nav-menu").css("top", headerHeight + "px");

            if ($(".CategoryLeftBar").length > 0) {
                $(".CategoryLeftBar").addClass("fixed-filterbar");
                $(".cat-header-area").addClass("fixed-filter");

                $(".fixed-filter").css("top", headerHeight + "px");
            }
        }
        else {
            $("header").removeClass("fixed-menu");
            $(".nav-menu").removeClass("fixed-nav-menu");

            $(".cat-header-area").css("top", "unset");
            $(".nav-menu").css("top", totalHeight + "px");

            if ($(".CategoryLeftBar").length > 0) {
                $(".CategoryLeftBar").removeClass("fixed-filterbar");
                $(".cat-header-area").removeClass("fixed-filter");
            }
        }

    }

    $(window).scroll(function () {
        updateHeaderStyles();
    });

    $(window).scroll(function () {

        if ($(window).scrollTop() >= 1) {
            $("header").addClass("fixed-menu");

            if ($(".CategoryLeftBar").length > 0) {
                $(".CategoryLeftBar").addClass("fixed-filterbar");
            }
        }
    });

    $(window).resize(function () {
        updateHeaderStyles();

        setTimeout(function () {
            setContentHeight();
        }, 1000);
    });

    // Search Events
    $('.headerSearchButton').live('click', function (e) {

        $(".search-new").css("display", "block");
        $("#SearchNewText_Close").css("display", "block");
        $("#SearchNewText_Search").css("display", "block");
        $(".search-new").focus();
        if ($(window).width() < 767) {
            $("#UserMenus").css("width", "100%");
        }
    });

    $("#SearchNewText_Close").live("click", function () {

        $(".search-new").css("display", "none");
        $("#SearchNewText_Close").css("display", "none");
        $("#SearchNewText_Search").css("display", "none");
        if ($(window).width() < 350) {
            $("#UserMenus").css("width", "40%");
        }
        else if ($(window).width() < 767) {
            $("#UserMenus").css("width", "50%");
        }
    });
    // End Search Events

    // Menu Events
    $('.RightBasket .SepetButton a').live('click', function (e) {
        //if (!isMobile(true)) {
        e.preventDefault();
        toggleBasket();
        //}
    });

    $('.RightBasket .SepetProducts .CartTitle .mobile-times').live('click', function (e) {
        if ($(window).width() < 991) {
            toggleBasket();
        }
    });

    if ($("#UserAndBasket").length > 0) {
        GetSepetIcerik(function (dt) {
            $("#UserAndBasket").html(dt);
        });
        SetWindowSize();
    }

    $(".BasketContainer .RemoveIcon").live("click", function () {
        var LangID = $("#LangID").val();
        var dataall = "";
        var Silid = 0;

        if ($(this).attr("data-id") != undefined && $(this).attr("data-id").length > 0) {
            Silid = $(this).attr("data-id").replace("sepetsil", "");
        }

        if ($(this).attr("data-all") == "true") {
            dataall = "&all=true";
        }

        if (1 == 1 || $(".ProductDetail").length > 0) {
            dataall += "&pd=true";
        }

        RemoveFromCardForMiniCard(Silid, LangID, dataall, $(this));
    });
    // Menu Events
});